export default "__VITE_ASSET__j4edQK9b__";